import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _toConsumableArray from 'babel-runtime/helpers/toConsumableArray';
import _extends from 'babel-runtime/helpers/extends';

import SearchBar from '@/components/SearchV3/index.vue';
import Pagination from '@/components/Pagination/index.vue';
import TableList from '@/components/TableList/index.vue';
import FilterBar from './components/filter/index.vue';
import searchMixin from '@/mixin/search';
import { getCreativeReportList } from '@/api/creative/report';
import { creativeType } from '../review/review.js';
import { downloadWithNewWindow } from '@/common/download.js';
import { cookRequestParams } from '@/common/request.js';
import { format, subDays } from 'date-fns';
import { v2Host } from '@/config/host';
import qs from 'qs';
import _ from 'lodash';

var defaultGroupBy = ['audit_date', 'adv_id', 'adv_name'];

var defaultQuery = {
  page: 1,
  page_size: 15,
  search_field: 'adv_name',
  keyword: '',
  creative_types: [],
  group_by: [],
  reject_rate_min: '',
  reject_rate_max: '',
  porn_rate_min: '',
  porn_rate_max: '',
  political_rate_min: '',
  political_rate_max: '',
  time: [format(subDays(new Date(), 7 - 1), 'YYYY-MM-DD'), format(new Date(), 'YYYY-MM-DD')]
};

export default {
  components: {
    SearchBar: SearchBar,
    Pagination: Pagination,
    TableList: TableList
  },
  mixins: [searchMixin],
  data: function data() {
    var keyFieldConfig = [{
      value: 'adv_id',
      label: '广告主ID'
    }, {
      value: 'adv_name',
      label: '广告主名称'
    }];

    return {
      query: _extends({}, defaultQuery),
      pagination: {
        total: 0
      },
      listLoading: true,
      keyFieldConfig: keyFieldConfig,
      list: [],
      checkGroups: [].concat(defaultGroupBy),
      selectDate: ''
    };
  },

  computed: {
    checkboxGroup: function checkboxGroup() {
      return [{
        label: '送审月份',
        prop: 'audit_month'
      }, {
        label: '送审日期',
        prop: 'audit_date'
      }, {
        label: '广告主ID',
        prop: 'adv_id',
        params: {
          innerText: function innerText(_ref) {
            var row = _ref.row;

            return row.adv_id ? row.adv_id : '-';
          }
        }
      }, {
        label: '广告主名称',
        prop: 'adv_name'
      }, {
        label: '素材类型',
        prop: 'creative_type',
        params: {
          innerText: function innerText(_ref2) {
            var row = _ref2.row;

            return row.creative_type ? creativeType.find(function (s) {
              return s.value === row.creative_type;
            }).label : '-';
          }
        }
      }];
    },
    basicColumnConfig: function basicColumnConfig() {
      return [{
        label: '送审素材数',
        prop: 'audit_count'
      }, {
        label: '拒审素材数据',
        prop: 'reject_count'
      }, {
        label: '拒审率（%）',
        prop: 'reject_rate'
      }, {
        label: '涉黄素材数',
        prop: 'porn_count'
      }, {
        label: '涉黄率（%）',
        prop: 'porn_rate'
      }, {
        label: '涉政素材数',
        prop: 'political_count'
      }, {
        label: '涉政率（%）',
        prop: 'political_rate'
      }];
    },
    tableColumnConfig: function tableColumnConfig() {
      var _this = this;

      var tableList = this.checkboxGroup.filter(function (d) {
        return _this.checkGroups.includes(d.prop);
      }).map(function (d) {
        return _extends({}, d);
      });

      return [].concat(_toConsumableArray(tableList), _toConsumableArray(this.basicColumnConfig));
    },
    formItemList: function formItemList() {
      var _this2 = this;

      var nameKeywordSearchItem = {
        prop: 'keyword',
        type: 'business',
        subtype: 'advertiser-selector',
        params: {
          filterable: true,
          valueKey: 'name',
          clearable: true
        }
      };
      var otherKeywordSearchItem = {
        prop: 'keyword',
        type: 'input',
        params: function params(_ref3) {
          var formValue = _ref3.formValue;

          return {
            disabled: false,
            readonly: false,
            clearable: true,
            style: 'width: 220px;',
            placeholder: formValue.search_field ? '按' + _this2.keyFieldConfig.find(function (item) {
              return item.value === formValue.search_field;
            }).label + '搜索' : '请输入搜索内容'
          };
        }
      };
      var keywordItem = this.query.search_field === 'adv_name' ? nameKeywordSearchItem : otherKeywordSearchItem;

      var list = {
        search_field: {
          type: 'select',
          prop: 'search_field',
          params: {
            clearable: false,
            filterable: true,
            style: 'width: 220px;',
            placeholder: '请选择搜索类型',
            options: [{
              label: '广告主ID',
              value: 'adv_id'
            }, {
              label: '广告主名称',
              value: 'adv_name'
            }],
            handleChange: function handleChange(val) {
              _this2.query.keyword = '';
            }
          }
        },
        keywordItem: keywordItem,
        creative_types: {
          type: 'select',
          prop: 'creative_types',
          params: {
            clearable: true,
            multiple: true,
            filterable: true,
            'collapse-tags': true,
            placeholder: '请选择素材类型',
            options: creativeType
          }
        },

        reject_rate: {
          component: FilterBar,
          model: _extends({}, this.query),
          handleChange: function handleChange(data) {
            _this2.filterChange(data);
          }
        },
        porn_rate: {
          component: FilterBar,
          model: _extends({}, this.query),
          handleChange: function handleChange(data) {
            _this2.filterChange(data);
          }
        },
        political_rate: {
          component: FilterBar,
          model: _extends({}, this.query),
          handleChange: function handleChange(data) {
            _this2.filterChange(data);
          }
        },
        time: {
          type: 'date-picker',
          subtype: 'daterange',
          prop: 'time',
          class: 'date-picker',
          params: {
            clearable: false,
            editable: false,
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
            handleBlur: function handleBlur() {
              self.selectDate = '';
            },
            pickerOptions: {
              /* eslint-disable no-mixed-operators */
              // 限定只能选择180天的日期
              disabledDate: function disabledDate(time) {
                if (time.getTime() > Date.now()) return true;
                if (self.selectDate) {
                  var days = 180 * 24 * 3600 * 1000;
                  return time.getTime() < self.selectDate || time.getTime() > self.selectDate + days;
                }
                return false;
              },

              onPick: function onPick(_ref4) {
                var maxDate = _ref4.maxDate,
                    minDate = _ref4.minDate;

                self.selectDate = minDate.getTime();
                if (maxDate) {
                  self.selectDate = '';
                }
              }
            }
          }
        }
      };
      return list;
    }
  },

  watch: {
    $route: function $route() {
      this.renderList();
    }
  },

  mounted: function mounted() {
    var _this3 = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this3.renderList();

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this3);
    }))();
  },


  methods: {
    cookSearchParams: function cookSearchParams() {
      var params = _extends({}, this.query, {
        group_by: this.checkGroups,
        start_time: this.query.time && this.query.time[0],
        end_time: this.query.time && this.query.time[1],
        reject_rate_min: this.query.reject_rate_min ? Number(this.query.reject_rate_min / 100) : '',
        reject_rate_max: this.query.reject_rate_max ? Number(this.query.reject_rate_max / 100) : '',
        porn_rate_min: this.query.porn_rate_min ? Number(this.query.porn_rate_min / 100) : '',
        porn_rate_max: this.query.porn_rate_max ? Number(this.query.porn_rate_max / 100) : '',
        political_rate_min: this.query.political_rate_min ? Number(this.query.political_rate_min / 100) : '',
        political_rate_max: this.query.political_rate_max ? Number(this.query.political_rate_max / 100) : ''
      });
      delete params.time;
      return params;
    },
    renderList: function renderList() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var params, res;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this4.listLoading = true;
                _context2.prev = 1;
                params = _this4.cookSearchParams();
                _context2.next = 5;
                return getCreativeReportList(params);

              case 5:
                res = _context2.sent;

                _this4.list = _.get(res, 'data.data.list') || [];
                _this4.pagination.total = _.get(res, 'data.data.total');
                _this4.listLoading = false;
                _context2.next = 14;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2['catch'](1);

                _this4.listLoading = false;

              case 14:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4, [[1, 11]]);
      }))();
    },
    resetSearch: function resetSearch() {
      this.checkGroups = [].concat(defaultGroupBy);
      this.query = defaultQuery;
      this.$router.push({
        name: 'butler.report.auth',
        query: _extends({}, this.query, {
          page: 1
        })
      });
    },
    handleCheckSearch: function handleCheckSearch() {
      this.query.page = 1;
      this.renderList();
    },
    downloadSheet: function downloadSheet() {
      var params = this.cookSearchParams();

      downloadWithNewWindow(v2Host + '/creative/report/export?' + qs.stringify(_extends({}, cookRequestParams(params))));
    },
    filterChange: function filterChange(data) {
      var _this5 = this;

      if (_.isArray(data)) {
        data.forEach(function (item) {
          _this5.query[item.prop] = item.value;
        });
      } else {
        this.query[data.prop] = data.value;
      }
    }
  }
};